import { partTypeTire } from "../../../../../constants/partTypes";
import { TirePartItem } from "../../../../../queries/useSearchTiresByVehicle";

export const partIsStaggered = (part: TirePartItem | null): boolean =>
  part?.partDetails.secondaryParts.some(
    (part) => part.itemType === partTypeTire
  ) ?? false;
